<template>
  <v-ons-list-item modifier="nodivider input">
    <slot name="left"></slot>
    <div class="center">
      <v-ons-input :type="inputType ? inputType : 'text'" v-model="inputValue" @input="updateValue"
                  :step="inputStep ? inputStep : 1" :placeholder="placeholder" :input-id="inputId"
                  modifier="underbar" :disabled="isDisabled" @keyup.enter="$emit('keyup-enter', $event)"
                  @wheel="onWheel"></v-ons-input>
      <!-- required => invalid pré-saisie -->
      <!-- type="email" => invalid pendant la saisie -->
      <v-ons-icon v-if="inputType == 'password'" @click="togglePassword" :icon="iconEyeClass"
                  size="24px" style="position: absolute; top: 9px; right: 27px;"></v-ons-icon>
    </div>
  </v-ons-list-item>
</template>

<script>
export default {
  props: ['value', 'placeholder', 'inputId', 'inputType', 'inputStep', 'isDisabled'],
  data() {
    return {
      inputValue: '',
      emitValue: undefined,
      isShowPassword: false,
    }
  },
  computed: {
    iconEyeClass() {
      var className = this.$md ? 'ion-md-eye' : 'ion-ios-eye';
      if(this.isShowPassword){
        className += '-off';
      }
      return className;
    }
  },
  watch: {
    value(val) {
      if(val != this.emitValue){
        // only if not from @input
        this.inputValue = val;
        this.emitValue = undefined;
      }
    }
  },
  methods: {
    updateValue(event) {
      // @input > watch value > watch inputValue
      this.emitValue = event.target.value;
      // Vue.prototype.$decimalSeparator = 1.1.toLocaleString().substring(1, 2);
      // .replace(/[,\.]/, this.$decimalSeparator);
      // impossible car 5. ==>> ""
      this.$emit('input', this.emitValue);
    },
    togglePassword() {
      this.$el.querySelector('input').type = (this.isShowPassword ? 'password' : 'text');
      this.isShowPassword = ! this.isShowPassword;
    },
    onWheel(event) {
      event.preventDefault();
    }
  },
  created() {
    this.inputValue = this.value;
  }
}
</script>
